import { http } from "config/http";
import { FilterData,} from "pages/forecast/forecastTypes";
import { ReplenishData } from "components/replenish/Replenish";



export const getInventoryData= async (filter: FilterData) => {



    try {
        const res: any = await http.post(`get_inventory_data`,filter)
        return { result: res?.data }
    } catch (error: any) {
        return { error: error.message }
    }
}


export const getInventoryGraphData= async (filter:FilterData ) => {



  try {
      const res: any = await http.post(`get_inventory_graph_data`, filter)
    
      return { result: res?.data }
  } catch (error: any) {
      return { error: error.message }
  }
}



export const getCategories = async () => {
    try {
        const res: any = await http.get(`get_all_categories?client_env=${localStorage.getItem("clientName")}`)
        return { result: res?.data.data }
    } catch (error: any) {
        return { error: error.message }
    }
}

export const getProducts = async (categoryName: string[] | undefined) => {

  try {
    const res: any = await http.get(`get_all_categories?client_env=${localStorage.getItem("clientName")}`, {
      params: { categories: categoryName?.join(",")},
    });

    return { result: res?.data };
  } catch (error: any) {
    return { error: error.message };
  }
};


export const getReplenishData = async (replenishData: ReplenishData)=>{


    try {
        const res: any = await http.post(`get_inventory_replenishment_data`, replenishData)
        return { result: res?.data }
    } catch (error: any) {
        return { error: error.message }
    }

}

  
  export const getUserPreference = async (userData: any) => {
    try {
      const res: any = await http.post(`get_user_preference`, userData)

      return { result: res?.data };
    } catch (error: any) {
      return { error: error.message };
    }
  };
  
